import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ConfirmHost } from "./components/ConfirmDialog";
import { AuthProvider } from "./context/AuthContext";
import { StableProvider } from "./context/StableContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import TesterOnboard from "./pages/TesterOnboard";
import Account from "./pages/Account";
import StableSelect from "./pages/StableSelect";
import Dashboard from "./pages/Dashboard";
import Horses from "./pages/Horses";
import HorseForm from "./pages/HorseForm";
import HorseDetail from "./pages/HorseDetail";
import ArchivePage from "./pages/Archive";
import Deadlines from "./pages/Deadlines";
import Farrier from "./pages/Farrier";
import Therapies from "./pages/Therapies";
import Feeding from "./pages/Feeding";
import Calendar from "./pages/Calendar";
import Settings from "./pages/Settings";
import Merchandising from "./pages/Merchandising";
import ActivityPlan from "./pages/ActivityPlan";
import PublicCollection from "./pages/PublicCollection";
import LegalPage from "./pages/LegalPage";
import LegalConsole from "./pages/LegalConsole";
import PlatformAdmin from "./pages/PlatformAdmin";
import InArrivo from "./pages/InArrivo";
import Stampe from "./pages/Stampe";
import People from "./pages/People";
import PersonDetail from "./pages/PersonDetail";
import Organizations from "./pages/Organizations";
import OrganizationDetail from "./pages/OrganizationDetail";
import PwaInstallGuidance from "./components/PwaInstallGuidance";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reimposta-password" element={<ResetPassword />} />
            <Route path="/verifica-email" element={<VerifyEmail />} />
            <Route path="/invito-tester/:token" element={<TesterOnboard />} />
            <Route path="/raccolta/:token" element={<PublicCollection />} />
            <Route path="/privacy" element={<LegalPage docType="privacy" />} />
            <Route path="/termini" element={<LegalPage docType="terms" />} />
            <Route
              path="/scuderie"
              element={
                <ProtectedRoute>
                  <StableProvider>
                    <StableSelect />
                  </StableProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/platform-admin"
              element={
                <ProtectedRoute>
                  <PlatformAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <StableProvider>
                    <AppLayout />
                  </StableProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/cavalli" element={<Horses />} />
              <Route path="/cavalli/nuovo" element={<HorseForm />} />
              <Route path="/cavalli/:id" element={<HorseDetail />} />
              <Route path="/cavalli/:id/modifica" element={<HorseForm />} />
              <Route path="/archivio" element={<ArchivePage />} />
              <Route path="/scadenze" element={<Deadlines />} />
              <Route path="/mascalcia" element={<Farrier />} />
              <Route path="/terapie" element={<Therapies />} />
              <Route path="/attivita" element={<ActivityPlan />} />
              <Route path="/alimentazione" element={<Feeding />} />
              <Route path="/calendario" element={<Calendar />} />
              <Route path="/impostazioni" element={<Settings />} />
              <Route path="/persone" element={<People />} />
              <Route path="/persone/:personId" element={<PersonDetail />} />
              <Route path="/organizzazioni" element={<Organizations />} />
              <Route path="/organizzazioni/:orgId" element={<OrganizationDetail />} />
              <Route path="/merchandising" element={<Merchandising />} />
              <Route path="/stampe" element={<Stampe />} />
              <Route path="/account" element={<Account />} />
              <Route path="/legal-console" element={<LegalConsole />} />
              <Route path="/in-arrivo" element={<InArrivo />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <ConfirmHost />
      <Toaster
        position="top-right"
        richColors
        offset={{ top: "calc(env(safe-area-inset-top) + 12px)", right: "calc(env(safe-area-inset-right) + 12px)", left: "calc(env(safe-area-inset-left) + 12px)", bottom: "calc(env(safe-area-inset-bottom) + 12px)" }}
        mobileOffset={{ top: "calc(env(safe-area-inset-top) + 12px)", right: "12px", left: "12px", bottom: "12px" }}
      />
      <PwaInstallGuidance />
    </div>
  );
}

export default App;
